import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "view-application-container"
}

import ResourceDetail from '@shell/components/ResourceDetail/index.vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: '_id',
  setup(__props) {

const store = useStore();
const route = store.$router.currentRoute.value;

const isApplication = route.params.resource === 'applications';

return (_ctx: any,_cache: any) => {
  return isApplication
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(ResourceDetail)
      ]))
    : (_openBlock(), _createBlock(ResourceDetail, { key: 1 }))
}
}

})